import * as React from 'react';
import { uniq } from 'lodash';
import { SeedCategory } from 'src/infrastructure/enums';
import { LayoutType } from 'src/infrastructure/LayoutTypes';
import { placeholderTypes } from 'src/infrastructure/placeholderTypes';
import { isDynaGro } from '../../../../../../../config';

import { IPage, IPlaceHolder, IDocument, IDragInfo } from '../../../../../../../infrastructure/interfaces';
import PagePlaceholder from '../../../common/PagePlaceholder';
import PageEditor from '../../../common/PageEditor';

export const createProductShelfImage = function(category: string, seedName: string | undefined): any {
  const styleClassName = 'catalog-product-shelf-image';
  var imagePath: string | undefined;
  if ((seedName != undefined) && (seedName.length > 0)) {
    switch (seedName) {
      case "Alfalfa":
        imagePath = require('../../Images/cropIcon_Alfalfa.png');
        break;
      case "Canola":
        imagePath = require('../../Images/cropIcon_Canola.png');
        break;
      case "Corn":
        imagePath = require('../../Images/cropIcon_Corn.png');
        break;
      case "Silage":
        imagePath = require('../../Images/cropIcon_Silage.png');
        break;
      case "Cotton":
        imagePath = require('../../Images/cropIcon_Cotton.png');
        break;
      case "Forage":
        imagePath = require('../../Images/cropIcon_ForageSorghum.png');
        break;
      case "Sorghum":
        imagePath = require('../../Images/cropIcon_Sorghum.png');
        break;
      case "Soybeans":
        imagePath = require('../../Images/cropIcon_Soybeans.png')
        break;
      case "Sunflower":
        imagePath = require('../../Images/cropIcon_Sunflower.png');
        break;
      case "Wheat":
        imagePath = require('../../Images/cropIcon_Wheat.png');
        break;
      case "Rice":
        imagePath = require('../../Images/cropIcon_Rice.png');
        break;
      case "Mustard":
        imagePath = require('../../Images/cropIcon_Mustard.png');
        break;
      case "Barley":
        imagePath = require('../../Images/cropIcon_Barley.png');
        break;
      case "Flax":
        imagePath = require('../../Images/cropIcon_Flax.png');
        break;
    }
  }
  if (imagePath == undefined) {
    switch (category) {
      case "Adjuvant":
        imagePath = require('../../Images/shelfIcon_adjuvant.png');
        break;
      case "Crop Protection":
        imagePath = require('../../Images/shelfIcon_cropProtection.png');
        break;
      case "Plant Nutrition":
        imagePath = require('../../Images/shelfIcon_plantNutrition.png');
        break;
      case "Seed Treatment":
        imagePath = require('../../Images/shelfIcon_seedTreatment.png');
        break;
    }
  }

  return (imagePath != undefined)
  ? (<img src={imagePath}
      className={styleClassName}>
     </img>)
  : null;
}
export interface IPageLayoutProps {
  page: IPage;
  second: boolean;
  document: IDocument | null;
  layout: string;
  isEditorRendering: boolean;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
}

export interface IPageLayoutState { }

export default class PageLayout extends React.Component<IPageLayoutProps, IPageLayoutState> {
  constructor(props: IPageLayoutProps) {
    super(props);
  }

  getPlaceholderCount = () :number => {

      let placeholderNumber;
      let otherpage = this.props.page.number -1;
      const pages = ((this.props.document && this.props.document.pages) || []);
      pages.forEach(p => {
        if(p.number === otherpage){
           placeholderNumber = p.placeholders.length;
        }
      })
      return placeholderNumber || 0;
  }

  renderDynaGroLogo(): any {
    const isAgronomySheet = this.props.page.layout === LayoutType.Agronomy;
    const isRightPage = this.props.page.position == "right";
    if (isAgronomySheet && isRightPage) {
      return null;
    }

    if (this.isSeedPage()) {
      const logoContainer = isDynaGro() ? 'dyna-gro-logo-container' : 'proven-logo-container';
      return <div className={logoContainer}></div>
    }
  }

  renderProducts(): any {
    return this.props.page.placeholders.map((p, i) => {
      const leftOrRight = (this.props.page.position == "right") ? "right" : "left";
      const index = this.props.second ? this.getPlaceholderCount() + i : i;

      return (
        
        this.props.isEditorRendering
        ? <PageEditor
          accepts={p.accepts}
          lastDroppedItem={p}
          onDrop={(data: any, dragInfo: any) => this.props.handleDrop(index, data, dragInfo)}
          removeProduct={this.props.removeProduct}
          index={index}
          key={i}
          page={this.props.page}
          document={this.props.document}
          layout={this.props.layout}
        />
        : (
            <div
              key={i}
              className={`${this.props.layout} ${leftOrRight} crop-page-view-drop
                ${(p.type === placeholderTypes.Image || p.type === placeholderTypes.Blank) ? 'crop-page-view-image-drop' : ''}
                isDropped
                ${(this.props.layout === "Catalog") ? `catalog-product` : ''}`}

              data-pagenumber={this.props.page.number}
            >
              <PagePlaceholder
                removeProduct={(data: any, index: number) => {}}
                index={index}
                model={p}
                isEditorView={false}
                pageNumber={this.props.page.number}
                document={this.props.document}
              />
            </div>
          )
      );
    });
  }

  prettyPrintNameForSeedCategory(seedCategory: SeedCategory): string {
    switch (seedCategory) {
      case SeedCategory.Alfalfa:
        return "Alfalfa";
      case SeedCategory.Canola:
        return "Canola";
      case SeedCategory.Corn:
        return "Corn";
      case SeedCategory.Silage:
        return "Silage";
      case SeedCategory.Cotton:
        return "Cotton";
      case SeedCategory.ForageSorghum:
        return "Forage";
      case SeedCategory.GrainSorghum:
      case SeedCategory.SudangrassSorghum:
        return "Sorghum";
      case SeedCategory.SoybeansOver3_5RM:
      case SeedCategory.SoybeansUnder3_5RM:
        return "Soybeans";
      case SeedCategory.Sunflower:
        return "Sunflower";
      case SeedCategory.HardRedSpringWheat:
      case SeedCategory.HardRedWinterWheat:
      case SeedCategory.SoftRedWinterWheat:
      case SeedCategory.SoftWhiteWinterWheat:
      case SeedCategory.DurumWheat:
        return "Wheat";
      case SeedCategory.Rice:
        return "Rice";
      case SeedCategory.Barley:
        return "Barley";
      case SeedCategory.Flax:
        return "Flax";
      case SeedCategory.Mustard:
        return "Mustard";
      default:
        return "Seed"
    }
  }

  isSeedPage(): boolean {
    const nonEmptyPlaceholders = this.props.page.placeholders.filter((p) => ((p != null) && (p.type != null)));
    const firstPlaceholder = nonEmptyPlaceholders[0];
    const isAgronomySheet = this.props.page.layout === LayoutType.Agronomy;
    if (isAgronomySheet) {
      return true;
    }
    const hasNoItems = ((firstPlaceholder == null) || (firstPlaceholder.data == null));

    if (hasNoItems
    || ((firstPlaceholder != null) && (firstPlaceholder.type != placeholderTypes.Product))) {
      return false;
    }

    // Protect against seed categories, which are objects instead of strings
    if ((firstPlaceholder!.data!.category == undefined)
        || firstPlaceholder!.data!.category["name"] != null) {
      return true;
    }

    return false;
  }

  renderPageNumberBar(): any {
    const containerClass = (this.props.page.position == "right")
      ? "catalog-page-side-container-right"
      : "catalog-page-side-container-left";

    const nonEmptyPlaceholders = this.props.page.placeholders.filter((p) => ((p != null) && (p.type != null)));
    const firstPlaceholder = nonEmptyPlaceholders[0];
    const seedTypesArray = this.props.page.placeholders.map((placeholder) => {
      if ((placeholder.data != null)
          && (placeholder.data.category != null)
          && (placeholder.data.category["id"] != null)) {
            return this.prettyPrintNameForSeedCategory(placeholder.data.category["id"]);
          }
      return undefined;
    })
    .filter((p) => p != undefined)

    const uniqueSeedTypes = uniq(seedTypesArray);
    const isAgronomySheet = this.props.page.layout === LayoutType.Agronomy;
    const hasNoItems = ((firstPlaceholder == null) || (firstPlaceholder.data == null));
    if ((!isAgronomySheet && hasNoItems)
    || ((firstPlaceholder != null) && (firstPlaceholder.type != placeholderTypes.Product))) {
      return null;
    }

    const seedCategoryString = isDynaGro() ? "Dyna-Gro" : "Proven";
    var category = isAgronomySheet ? seedCategoryString : firstPlaceholder!.data!.category;
    // Protect against seed categories, which are objects instead of strings
    if ((category == undefined) || category["name"] != null) {
      category = seedCategoryString;
    }
    const categoryStyleBaseClass = "catalog-page-category";
    const categoryStyleClass = (category == seedCategoryString)
      ? categoryStyleBaseClass + " Seed"
      : categoryStyleBaseClass;
    const seedName = ((category == seedCategoryString) && (uniqueSeedTypes.length == 1) && uniqueSeedTypes[0] != undefined)
    ? uniqueSeedTypes[0]
    : "";
    const longCategoryName = ((seedName != undefined) && (seedName.length > 0))
     ? category + " | " + seedName!
     : category;

    return(
      <div className={containerClass}>
        <div className="catalog-page-side">
          <div className={categoryStyleClass}>
            {createProductShelfImage(category, seedName)}
            <span className='catalog-page-category-contents'>{longCategoryName}</span>
          </div>
        </div>
        <div className='catalog-page-number'>
            <span>{this.props.page.number}</span>
          </div>
      </div>
    );
  }

  render() {
    const containerClass = (this.props.page.position == "right")
      ? "page-layout-container-right"
      : "page-layout-container-left";
      return(
        <div className={containerClass}>
          {this.renderProducts()}
          {this.renderPageNumberBar()}
          {this.renderDynaGroLogo()}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Catalog/Components/PageLayout/PageLayout.tsx